import { inject, Injectable } from '@angular/core';
import { AbstractTrackingSettingsProviderService, CURRENT_URL, PREVIOUS_URL, TrackingData } from '@iot-platform/core';
import { TrackingFacade } from '@iot-platform/data-access';
import { Observable } from 'rxjs';

@Injectable()
export class TrackingSettingsProviderService extends AbstractTrackingSettingsProviderService {
  private readonly currentUrl$: Observable<string> = inject(CURRENT_URL);
  private readonly previousUrl$: Observable<string> = inject(PREVIOUS_URL);
  private readonly trackingFacade: TrackingFacade = inject(TrackingFacade);

  getTrackingData$(): Observable<TrackingData> {
    return this.trackingFacade.additionalTrackingData$;
  }

  getCurrentUrl$(): Observable<string> {
    return this.currentUrl$;
  }

  getPreviousUrl$(): Observable<string> {
    return this.previousUrl$;
  }
}
